import { render } from "./CoursesSidebarPage.vue?vue&type=template&id=94613ea6&ts=true"
import script from "./CoursesSidebarPage.vue?vue&type=script&lang=ts"
export * from "./CoursesSidebarPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__